<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="objDisclaimer != null && objDisclaimer?.Abrir">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_pep">
                            <div style=" width: 100%;">
                             <img style="width: 25px; height: 25px; cursor: pointer;transform: rotate(5deg);" src="@/assets/info.png" />
                            </div>
                            <div style=" width: 100%;">
                            <h2 :title="{titulo}">{{ titulo.length > 30 ? titulo.substring(0, 30) + '...' : titulo }} </h2>
                            </div>
                            <div style="height: 350px; width: 100%; overflow-y: scroll; border: 0.5px solid #dadada;">
                                <span v-html="conteudo"></span>
                            </div>

                            
                      <div class="buttonsAcoes" style="padding-bottom: 30px;">
                          <button class="btnDefault" style="width: 290px" @click="closeModal">Entendi</button>
                      </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            objDisclaimer: "GET_MODAL_DISCLAIMER_INFORMATIVO",
            listaDisclaimer: "GET_LISTA_DISCLAIMER",
            user: 'auth/user',
        }),
    },
    data() {
        return {
            titulo: '',
            conteudo: '',
        };
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_DISCLAIMER_INFORMATIVO", false);
        },
    },
    watch: {
        objDisclaimer(){
            if(this.objDisclaimer != null && this.objDisclaimer.Abrir == true){
            if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente&& disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao) != null){
                var obj = this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente
                && disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao);
                this.titulo = obj.Titulo;
                this.conteudo = obj.Texto;

          }else{
                this.titulo = 'Sem informações adicionais';
                this.conteudo = 'Não há instruções adicionais para essa sessão';
          }
            }


        }
    }
};
</script>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_pep{

    margin-top: 30px !important;
    width: 450px !important;
    align-content: center;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centraliza verticalmente */
    align-items: center;     /* Centraliza horizontalmente */
    height: 100vh;           /* Define altura da tela */

    h2{
    margin-bottom: 20px !important;
        max-width: 400px;
        text-align: center;   
    }

    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;

            max-width: 400px;
    }



}


.modalpep .modal__wrapper .modal__container.reset {
        width: 450px;
        height: 200px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
